import { useSelector } from 'react-redux';
import queries from '../../../../api/queries/SubscriptionQueries';
import paymentQueries from '../../../../api/queries/PaymentQueries';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { errorToast, successToast } from 'components/common/Toast/Toast';
import { useUserApi } from 'hooks/useUserApi';
import { useState } from 'react';

export const useSubscriptionLogic = () => {
  const shopTier = useSelector((state) => state.nonPersistedReducers?.shopTierSliceReducer?.shopTier);
  const shopId = useSelector((state) => state.nonPersistedReducers?.shopSliceReducer?.shopId);
  const user = useSelector((state) => state.nonPersistedReducers?.userSliceReducer?.currentUser);
  const queryClient = useQueryClient();
  const [paymentOpen, setPaymentOpen] = useState(false);

  const { getCurrentUser } = useUserApi();

  const fetchPublicTiersQuery = useQuery({
    queryKey: ['publicTiers'],
    queryFn: () => queries.getPublicShopTiers(),
    retry: (failureCount, error) => (error.response.status === 404 ? false : true),
    refetchOnWindowFocus: false
  });

  const fetchCardRegister = useQuery({
    queryKey: ['cardRegistration'],
    queryFn: () => paymentQueries.getRegistration({ shopId: shopId }),
    refetchOnWindowFocus: false,
    enabled: user?.ownedShops?.length > 0
  });

  const assignTier = useMutation({
    mutationFn: ({ tierId, isAnnual }) => {
      queries.assignShopTier({ shopId: shopId, tierId: tierId, isYearlyPricing: isAnnual });
    },
    onSuccess: (data, variables) => {
      setTimeout(() => {
        queryClient.invalidateQueries([shopId, 'shopTier']);
        getCurrentUser();
        variables?.setOpen(false);
      }, 2000);
    },
    onError: () => errorToast('Előfizetés aktiválása sikertelen! Kérjük próbáld újra később!')
  });

  const unassignTier = useMutation({
    mutationFn: () => queries.unassignShopTier({ shopId: shopId, tierId: shopTier?.id }),
    onSuccess: (data, variables) => {
      setTimeout(() => {
        queryClient.invalidateQueries([shopId, 'shopTier']);
        getCurrentUser();
        variables?.setOpen(false);
      }, 2000);
    },
    onError: () => errorToast('Előfizetés lemondása sikertelen! Kérjük próbáld újra később!')
  });

  const manualPayment = useMutation({
    mutationFn: () => paymentQueries.manualPayment({ shopId: shopId }),
    onSuccess: () => {
      successToast('Manuális fizetés sikeres!');
      setTimeout(() => {
        queryClient.invalidateQueries([shopId, 'shopTier']);
        getCurrentUser();
        setPaymentOpen(false);
      }, 2000);
    },
    onError: () => errorToast('Manuális fizetés sikertelen! Kérjük próbáld újra később!')
  });

  return {
    shopTier,
    fetchPublicTiersQuery,
    assignTier,
    unassignTier,
    shopId,
    fetchCardRegister,
    user,
    manualPayment,
    paymentOpen,
    setPaymentOpen
  };
};
